// App
export const SET_INITIALIZED = "setInitialized";
export const SET_KEY = "setKey";
export const SET_ERROR = "setError";
export const SET_KEY_NESTED = "setKeyNested";
export const DEL_KEY_NESTED = "delKeyNested";

// Modals
export const SHOW_MODAL_ADD = "showModalAdd";

// Auth
export const SET_AUTH = "setUser";
export const SET_WALLET = "setWallet";
export const PURGE_AUTH = "purgeAuth";

// Channels
export const SET_CHANNEL = "setChannel";

// Topics
export const SET_TOPIC = "setTopic";
export const SET_COMMENT = "setComment";
export const SET_REACTION = "setReaction";
export const DEL_REACTION = "delReaction";
export const SET_SUBCOMMENT = "setSubComment";
export const SHOW_COMMENT_EDIT = "showCommentEdit";
export const HIDE_COMMENT_EDIT = "hideCommentEdit";
export const SET_QUERY_RESULT = "setQueryResult";
export const DEL_TOPIC = "delTopic";
export const DEL_COMMENT = "delComment";
export const DEL_SUBCOMMENT = "delSubComment";
// Members
export const SET_MEMBER = "setMember";
export const SET_MEMBERS_ONLINE = "setMemberOnline";
export const SET_TOTAL_MEMBERS = "setTotalMembers";

//World
export const SET_WORLD = "setWorld";
export const SET_CURRENT_WORLD = "setCurrentWorld";
export const ADD_MESSAGE = "addMessage";

//Numberologie
export const SET_CURRENT_STEP_IN_NUMEROLOGIE = "setCurrentStepInNumerologie";
export const SAVE_AUDIO_FILES_IN_NUMEROLOGIE = "saveAudioFilesInNumerologie";

//common
export const SET_CONFIRM_DIALOG = "setConfirmDialog";
export const SET_DELETE_RESULT = "setDeleteResult";
export const SET_EXPAND_MENU = "setExpandMenu";
export const SET_USER_TO_VIEW = "setUserToView";

//Notification
export const SET_NOTIFICATION_EVENT = "setNotificationEvent";
export const DEL_NOTIFICATION_EVENT = "delNotificationEvent";
export const SET_UNREAD_COUNT = "setUnreadCount";
export const SET_RECENT_NOTIFICATION = "setRecentNotification";

//Room
export const SET_ROOM = "setRoom";
export const SET_TEXTUAL_MESSAGE = "setTextualMessages";
export const DEL_TEXTUAL_MESSAGE = "deleteTextualMessages";

//Chat
export const SET_CHAT_CHANNEL = "setChatChannel";
export const SET_CHAT_USER = "setChatUsers";
export const SET_CHAT_MESSAGES = "setChatMessages";
export const RESET_CHAT_MESSAGE = "resetChatMessage";
export const DEL_CHAT_MESSAGE = "deleteChatMessage";

export const RESET_STORE = "resetStore";
